import * as React from "react";
import { FormSection } from "./components/FormSection";
import Heading from "../../components/Heading";
import InputField from "../../components/Forms/InputField";
import { TextArea } from "../../components/Forms/TextArea";
import { ActionButton } from "../../components/Forms/ActionButton";
import ImageInput from "../../components/Forms/ImageInput";
import { getNgoDetails, updateNgo } from "../../api/users";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from "react-router-dom";

const NgoEdit = () => {

    const { state } = useLocation();
    
    const [formData, setFormData] = React.useState([
        { label: 'NGO Name', placeholder: 'Enter NGO Name', name: 'ngoName', value: '' },
        { label: 'Branch Address', placeholder: 'Enter Branch Address', name: 'branchAddress', value: '' },
        { label: 'Phone Number', placeholder: 'Enter Phone Number', name: 'phone', value: '' },
        { label: 'Email', placeholder: 'Enter Email', name: 'email', value: '' },
        { label: 'Headquarter Address', placeholder: 'Enter Headquarter Address', name: 'headquarterAddress', value: '' },
        { label: 'Website URL', placeholder: 'Enter Website URL', name: 'websiteUrl', value: '' },
        { label: '80G Registration', placeholder: 'Enter 80G Registration', name: 'registration80G', value: '' },
        { label: '12A Registration', placeholder: 'Enter 12A Registration', name: 'registration12A', value: '' },
        { label: 'FCRA Status', placeholder: 'Enter FCRA Status', name: 'fcraStatus', value: '' },
        { label: 'Country', placeholder: 'Select Country', name: 'country', value: '', type: 'text' },
        { label: 'Tax Exemption Certificate details', placeholder: 'Enter Tax Exemption Certificate details', name: 'taxExemptionCertificateDetails', value: '' },
        { label: 'Date of Establishment', placeholder: 'Enter Date of Establishment', name: 'dateOfEstablishment', value: '', type: 'date' },
    ]);

    const [socialFields, setSocialFields] = React.useState([
        { label: 'LinkedIn Account Link', placeholder: 'Enter LinkedIn Account Link', name: 'linkedIn', value: '' },
        { label: 'Instagram Account Link', placeholder: 'Enter Instagram Account Link', name: 'instagram', value: '' },
        { label: 'Facebook Account Link', placeholder: 'Enter Facebook Account Link', name: 'facebook', value: '' },
        { label: 'Twitter Account Link', placeholder: 'Enter Twitter Account Link', name: 'twitter', value: '' },
        { label: 'YouTube Account Link', placeholder: 'Enter YouTube Account Link', name: 'youtube', value: '' },
        // Website link captured in base fields as websiteUrl
    ]);

    const [pocFields, setPocFields] = React.useState([
        { label: 'Name of the primary contact person', placeholder: 'Enter Name of the primary contact person', name: 'primaryContactPerson', value: '' },
        { label: 'Designation/Role', placeholder: 'Enter Designation/Role', name: 'pocDesignation', value: '' },
        { label: 'Phone Number', placeholder: 'Enter Phone Number', name: 'pocPhone', value: '' },
        { label: 'Mobile Number', placeholder: 'Enter Mobile Number', name: 'pocMobile', value: '' },
        { label: 'Email Address', placeholder: 'Enter Email Address', name: 'pocEmail', value: '' },
    ]);

    const [accountFields, setAccountFields] = React.useState([
        { label: 'Username', placeholder: 'Enter Username', name: 'username', value: '' },
        { label: 'Password', placeholder: 'Enter Password', name: 'password', value: '', type: 'password' },
        { label: 'Display Name', placeholder: 'Enter Display Name', name: 'displayName', value: '' },
    ]);

    const [organizationalFields, setOrganizationalFields] = React.useState([
        { label: 'Description of the NGO’s mission, vision, and objectives', placeholder: 'Enter Description of the NGO’s mission, vision, and objectives', name: 'visionAndObjective', value: '' },
        { label: 'Key Focus Areas ', placeholder: 'Enter Key Focus Areas (e.g., environmental conservation, education, healthcare)', name: 'keyFocusArea', value: '' },
        { label: 'Key Programs/Projects', placeholder: 'Enter Key Programs/Projects', name: 'keyProgram', value: '' },
        { label: 'Funding Sources', placeholder: 'Select Funding Sources', name: 'fundingSources', value: '' },
        { label: 'Specific activities or project to promote through the partnership', placeholder: 'Enter Specific activities or projects to promote through the partnership', name: 'activitiesToPromoteThroughThePartnership', value: '' },
        { label: 'Geographic scope of operations', placeholder: 'Enter Geographic scope of operations (local, regional, national, or international)', name: 'geographicScopeOfOperations', value: '' },
        { label: 'Target beneficiaries', placeholder: 'EnterTarget beneficiaries (e.g., communities, endangered species, youth)', name: 'targetBeneficiaries', value: '' },
    ]);

    const [partnershipFields, setPartnershipFields] = React.useState([
        { label: 'Types of Engagement', placeholder: 'Enter Types of Engagement (select one or both)', name: 'typesOfEngagement', value: '' },
        { label: 'Details Of Tree Plantation Drive', placeholder: 'Write Details Of Tree Plantation Drive (preferred location, frequency, type of trees planted, number of trees planted)', name: 'detailsOfTreePlantationDrive', value: '' },
        { label: 'Preferred Location', placeholder: 'Enter Preferred Location', name: 'preferredLocation', value: '' },
        { label: 'Frequency', placeholder: 'Enter Frequency', name: 'frequency', value: ''},
        { label: 'Type of trees planted', placeholder: 'Enter Type of trees planted', name: 'typeOfTreesPlanted', value: ''},
        { label: 'Number of trees planted', placeholder: 'Enter Number of trees planted', name: 'numberOfTreesPlanted', value: '', type: 'number' },
        { label: 'Details Of Events', placeholder: 'Write Details Of Events (type of events (e.g beach clean up, vaccination camp etc), preferred location, Volunteer needs)', name: 'detailsOfEvents', value: '' },
        { label: 'Type of events', placeholder: 'Enter Type of events', name: 'typeOfEvents', value: '' },
        { label: 'Preferred Location', placeholder: 'Enter Preferred Location', name: 'location', value: '' },
        { label: 'Volunteer needs', placeholder: 'Enter Volunteer needs', name: 'volunteerNeeds', value: '' },
    ]);

    const [ComplianceFields, setComplianceFields] = React.useState([
        { label: 'Signed partnership agreement or terms and conditions acceptance', placeholder: 'Enter Signed partnership agreement or terms and conditions acceptance', name: 'signedPartnershipAgreementOrTermsAndConditionsAcceptance', value: '' },
        { label: 'Data privacy compliance acknowledgment ', placeholder: 'Enter Data privacy compliance acknowledgment ', name: 'dataPrivacyComplianceAcknowledgment', value: '' },
    ]);

    const [impactFields, setImpactFields] = React.useState([
        { label: 'Metrics or data points they plan to track', placeholder: 'Enter Metrics or data points they plan to track (e.g., number of trees planted, total points converted in tree planting, number of volunteers recruited thru the app etc)', name: 'metricsOrDataPointsTheyPlanToTrack', value: '' },
        { label: 'Reporting frequency', placeholder: 'Reporting frequency (e.g., monthly, quarterly updates)', name: 'reportingFrequency', value: '' },
        { label: 'Remarks/Notes', placeholder: 'Enter Remarks/Notes', name: 'remarksOrNotes', value: '' },
        // { label: 'Attachments', placeholder: 'Enter Attachments', name: 'attachments', value: [] },
    ]);
    
    const [image, setImage] = React.useState(null);

    const handleChange = (index, newValue) => {
        setFormData(prevFields =>
            prevFields.map((field, i) =>
                i === index ? { ...field, value: newValue } : field
            )
        );
    };
    const handleSocialChange = (index, newValue) => {
        setSocialFields(prevFields =>
            prevFields.map((field, i) =>
                i === index ? { ...field, value: newValue } : field
            )
        );
    };
    const handlePocChange = (index, newValue) => {
        setPocFields(prevFields =>
            prevFields.map((field, i) =>
                i === index ? { ...field, value: newValue } : field
            )
        );
    };
    const handleAccountChange = (index, newValue) => {
        setAccountFields(prevFields =>
            prevFields.map((field, i) =>
                i === index ? { ...field, value: newValue } : field
            )
        );
    };
    const handleOrgChange = (index, newValue) => {
        setOrganizationalFields(prevFields =>
            prevFields.map((field, i) =>
                i === index ? { ...field, value: newValue } : field
            )
        );
    };
    const handlePartnerChange = (index, newValue) => {
        setPartnershipFields(prevFields =>
            prevFields.map((field, i) =>
                i === index ? { ...field, value: newValue } : field
            )
        );
    };
    const handleComplianceChange = (index, newValue) => {
        setComplianceFields(prevFields =>
            prevFields.map((field, i) =>
                i === index ? { ...field, value: newValue } : field
            )
        );
    };
    const handleImpactChange = (index, newValue) => {
        setImpactFields(prevFields =>
            prevFields.map((field, i) =>
                i === index ? { ...field, value: newValue } : field
            )
        );
    };

    // const validateForm = () => {
    //     const newErrors = {};
    //     if (!formData.companyName) newErrors.companyName = "Company name is required";
    //     if (!formData.email) newErrors.email = "Email is required";
    //     if (!formData.phoneNumber) newErrors.phoneNumber = "Phone number is required";

    //     // setErrors(newErrors);
    //     return Object.keys(newErrors).length === 0;
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // if (!validateForm()) return;
        const data = {
            ngoName: formData[0].value,
            branchAddress: formData[1].value,
            phone: formData[2].value,
            email: formData[3].value,
            headquarterAddress: formData[4].value,
            websiteUrl: formData[5].value,
            registration80G: formData[6].value,
            registration12A: formData[7].value,
            fcraStatus: formData[8].value,
            country: formData[9].value,
            taxExemptionCertificateDetails: formData[10].value,
            dateOfEstablishment: formData[11].value,
            linkedIn: socialFields[0].value,
            instagram: socialFields[1].value,
            facebook: socialFields[2].value,
            twitter: socialFields[3].value,
            youtube: socialFields[4].value,
            website: socialFields[5].value,
            primaryContactPerson: pocFields[0].value,
            pocDesignation: pocFields[1].value,
            pocPhone: pocFields[2].value,
            pocMobile: pocFields[3].value,
            pocEmail: pocFields[4].value,
            username: accountFields[0].value,
            password: accountFields[1].value,
            displayName: accountFields[2].value,
            visionAndObjective: organizationalFields[0].value,
            keyFocusArea: organizationalFields[1].value,
            keyProgram: organizationalFields[2].value,
            keyProjects: organizationalFields[3].value,
            fundingSources: organizationalFields[4].value,
            activitiesToPromoteThroughThePartnership: organizationalFields[5].value,
            geographicScopeOfOperations: organizationalFields[6].value,
            targetBeneficiaries: organizationalFields[7].value,
            typesOfEngagement: partnershipFields[0].value,
            detailsOfTreePlantationDrive: partnershipFields[1].value,
            preferredLocation: partnershipFields[2].value,
            frequency: partnershipFields[3].value,
            typeOfTreesPlanted: partnershipFields[4].value,
            numberOfTreesPlanted: partnershipFields[5].value,
            detailsOfEvents: partnershipFields[6].value,
            typeOfEvents: partnershipFields[7].value,
            location: partnershipFields[8].value,
            volunteerNeeds: partnershipFields[9].value,
            signedPartnershipAgreementOrTermsAndConditionsAcceptance: ComplianceFields[0].value,
            dataPrivacyComplianceAcknowledgment: ComplianceFields[1].value,
            metricsOrDataPointsTheyPlanToTrack: impactFields[0].value,
            reportingFrequency: impactFields[1].value,
            remarksOrNotes: impactFields[2].value,
            isImagePresent: image.type ? true : false,
        };
        updateNgo(state._id, data, image, toast);
    };

    React.useEffect(() => {
        getNgoDetails(state._id, formData, setFormData, socialFields, setSocialFields, pocFields, setPocFields, accountFields, setAccountFields, organizationalFields, setOrganizationalFields, partnershipFields, setPartnershipFields, ComplianceFields, setComplianceFields, impactFields, setImpactFields, setImage, toast);
        // eslint-disable-next-line
    }, []);
    
    return (
        <form className="flex flex-col border border-red" noValidate>
            <Heading
                text={"NGO Edit Form"}
            />

            <FormSection title="">
                <div className="flex flex-wrap gap-6 items-start w-full max-md:max-w-full">
                    <div className="flex flex-col grow shrink text-sm min-w-[240px] w-[844px] max-md:max-w-full">
                        <div className="flex flex-wrap gap-3 items-center">
                            <InputField
                                label={formData[0].label}
                                name={formData[0].name}
                                value={formData[0].value}
                                placeholder={formData[0].placeholder}
                                type={formData[0].type}
                                required={formData[0].required}
                                onChange={e => handleChange(0, e.target.value)}
                            />
                            <InputField
                                label={formData[1].label}
                                name={formData[1].name}
                                value={formData[1].value}
                                placeholder={formData[1].placeholder}
                                type={formData[1].type}
                                required={formData[1].required}
                                onChange={e => handleChange(1, e.target.value)}
                            />
                        </div>
                        <div className="flex flex-wrap gap-3 items-center">
                            <InputField
                                label={formData[2].label}
                                name={formData[2].name}
                                value={formData[2].value}
                                placeholder={formData[2].placeholder}
                                type={formData[2].type}
                                required={formData[2].required}
                                onChange={e => handleChange(2, e.target.value)}
                            />
                            <InputField
                                label={formData[3].label}
                                name={formData[3].name}
                                value={formData[3].value}
                                placeholder={formData[3].placeholder}
                                type={formData[3].type}
                                required={formData[3].required}
                                onChange={e => handleChange(3, e.target.value)}
                            />
                        </div>
                        <InputField
                            label={formData[4].label}
                            name={formData[4].name}
                            value={formData[4].value}
                            placeholder={formData[4].placeholder}
                            type={formData[4].type}
                            required={formData[4].required}
                            onChange={e => handleChange(4, e.target.value)}
                        />
                    </div>
                    <div className="flex flex-col grow shrink w-36 min-h-[250px]">
                        {/* <ImageUpload
                            label="Company Logo"
                            onChange={handleFileChange('logo')}
                            value={formData.logo}
                            maxFiles={1}
                            error={errors.logo}
                        /> */}
                        <ImageInput
                            image={image}
                            setImage={setImage}
                            text={'NGO Logo'}
                        />
                    </div>
                </div>
                <InputField
                    label={formData[5].label}
                    name={formData[5].name}
                    value={formData[5].value}
                    placeholder={formData[5].placeholder}
                    type={formData[5].type}
                    required={formData[5].required}
                    onChange={e => handleChange(5, e.target.value)}
                />
                <div className="flex flex-wrap gap-3">
                    <InputField
                        label={formData[6].label}
                        name={formData[6].name}
                        value={formData[6].value}
                        placeholder={formData[6].placeholder}
                        type={formData[6].type}
                        required={formData[6].required}
                        onChange={e => handleChange(6, e.target.value)}
                    />
                    <InputField
                        label={formData[7].label}
                        name={formData[7].name}
                        value={formData[7].value}
                        placeholder={formData[7].placeholder}
                        type={formData[7].type}
                        required={formData[7].required}
                        onChange={e => handleChange(7, e.target.value)}
                    />
                </div>
                <div className="flex flex-wrap gap-3">
                    <InputField
                        label={formData[8].label}
                        name={formData[8].name}
                        value={formData[8].value}
                        placeholder={formData[8].placeholder}
                        type={formData[8].type}
                        required={formData[8].required}
                        onChange={e => handleChange(8, e.target.value)}
                    />
                    <InputField
                        label={formData[9].label}
                        name={formData[9].name}
                        value={formData[9].value}
                        placeholder={formData[9].placeholder}
                        type={formData[9].type}
                        required={formData[9].required}
                        onChange={e => handleChange(9, e.target.value)}
                    />
                </div>
                <div className="flex flex-wrap gap-3">
                    <InputField
                        label={formData[10].label}
                        name={formData[10].name}
                        value={formData[10].value}
                        placeholder={formData[10].placeholder}
                        type={formData[10].type}
                        required={formData[10].required}
                        onChange={e => handleChange(10, e.target.value)}
                    />
                    <InputField
                        label={formData[11].label}
                        name={formData[11].name}
                        value={formData[11].value ? new Date(formData[11].value).toISOString().split("T")[0] : ''}
                        placeholder={formData[11].placeholder}
                        type={formData[11].type}
                        required={formData[11].required}
                        onChange={e => handleChange(11, e.target.value)}
                    />
                </div>
            </FormSection>

            <FormSection title="Social Media Details">
                <div className="flex flex-wrap gap-3">
                    <InputField
                        label={socialFields[0].label}
                        name={socialFields[0].name}
                        value={socialFields[0].value}
                        placeholder={socialFields[0].placeholder}
                        type={socialFields[0].type}
                        required={socialFields[0].required}
                        onChange={e => handleSocialChange(0, e.target.value)}
                    />
                    <InputField
                        label={socialFields[1].label}
                        name={socialFields[1].name}
                        value={socialFields[1].value}
                        placeholder={socialFields[1].placeholder}
                        type={socialFields[1].type}
                        required={socialFields[1].required}
                        onChange={e => handleSocialChange(1, e.target.value)}
                    />
                </div>
                <div className="flex flex-wrap gap-3">
                    <InputField
                        label={socialFields[2].label}
                        name={socialFields[2].name}
                        value={socialFields[2].value}
                        placeholder={socialFields[2].placeholder}
                        type={socialFields[2].type}
                        required={socialFields[2].required}
                        onChange={e => handleSocialChange(2, e.target.value)}
                    />
                    <InputField
                        label={socialFields[3].label}
                        name={socialFields[3].name}
                        value={socialFields[3].value}
                        placeholder={socialFields[3].placeholder}
                        type={socialFields[3].type}
                        required={socialFields[3].required}
                        onChange={e => handleSocialChange(3, e.target.value)}
                    />
                </div>
                <div className="flex flex-wrap gap-3">
                    <InputField
                        label={socialFields[4].label}
                        name={socialFields[4].name}
                        value={socialFields[4].value}
                        placeholder={socialFields[4].placeholder}
                        type={socialFields[4].type}
                        required={socialFields[4].required}
                        onChange={e => handleSocialChange(4, e.target.value)}
                    />
                    <InputField
                        label={socialFields[5].label}
                        name={socialFields[5].name}
                        value={socialFields[5].value}
                        placeholder={socialFields[5].placeholder}
                        type={socialFields[5].type}
                        required={socialFields[5].required}
                        onChange={e => handleSocialChange(5, e.target.value)}
                    />
                </div>
            </FormSection>

            <FormSection title="Point Of Contact">
                <div className="flex gap-3">
                    <InputField
                        label={pocFields[0].label}
                        name={pocFields[0].name}
                        value={pocFields[0].value}
                        placeholder={pocFields[0].placeholder}
                        type={pocFields[0].type}
                        required={pocFields[0].required}
                        onChange={e => handlePocChange(0, e.target.value)}
                    />
                    <InputField
                        label={pocFields[1].label}
                        name={pocFields[1].name}
                        value={pocFields[1].value}
                        placeholder={pocFields[1].placeholder}
                        type={pocFields[1].type}
                        required={pocFields[1].required}
                        onChange={e => handlePocChange(1, e.target.value)}
                    />
                </div>
                <div className="flex gap-3">
                    <InputField
                        label={pocFields[2].label}
                        name={pocFields[2].name}
                        value={pocFields[2].value}
                        placeholder={pocFields[2].placeholder}
                        type={pocFields[2].type}
                        required={pocFields[2].required}
                        onChange={e => handlePocChange(2, e.target.value)}
                    />
                    <InputField
                        label={pocFields[3].label}
                        name={pocFields[3].name}
                        value={pocFields[3].value}
                        placeholder={pocFields[3].placeholder}
                        type={pocFields[3].type}
                        required={pocFields[3].required}
                        onChange={e => handlePocChange(3, e.target.value)}
                    />
                    <InputField
                        label={pocFields[4].label}
                        name={pocFields[4].name}
                        value={pocFields[4].value}
                        placeholder={pocFields[4].placeholder}
                        type={pocFields[4].type}
                        required={pocFields[4].required}
                        onChange={e => handlePocChange(4, e.target.value)}
                    />
                </div>
            </FormSection>

            <FormSection title="Account Details">
                <div className="flex gap-3">
                    <InputField
                        label={accountFields[0].label}
                        name={accountFields[0].name}
                        value={accountFields[0].value}
                        placeholder={accountFields[0].placeholder}
                        type={accountFields[0].type}
                        required={accountFields[0].required}
                        onChange={e => handleAccountChange(0, e.target.value)}
                    />
                    <InputField
                        label={accountFields[1].label}
                        name={accountFields[1].name}
                        value={accountFields[1].value}
                        placeholder={accountFields[1].placeholder}
                        type={accountFields[1].type}
                        required={accountFields[1].required}
                        onChange={e => handleAccountChange(1, e.target.value)}
                        disabled={true}
                    />
                    <InputField
                        label={accountFields[2].label}
                        name={accountFields[2].name}
                        value={accountFields[2].value}
                        placeholder={accountFields[2].placeholder}
                        type={accountFields[2].type}
                        required={accountFields[2].required}
                        onChange={e => handleAccountChange(2, e.target.value)}
                    />
                </div>
            </FormSection>

            <FormSection title="Organizational Details">
                <TextArea
                    label={organizationalFields[0].label}
                    placeholder={organizationalFields[0].placeholder}
                    minHeight="180px"
                    name={organizationalFields[0].name}
                    type={organizationalFields[0].type}
                    value={organizationalFields[0].value}
                    onChange={e => handleOrgChange(0, e.target.value)}
                />
                <InputField
                    label={organizationalFields[1].label}
                    name={organizationalFields[1].name}
                    value={organizationalFields[1].value}
                    placeholder={organizationalFields[1].placeholder}
                    type={organizationalFields[1].type}
                    required={organizationalFields[1].required}
                    onChange={e => handleOrgChange(1, e.target.value)}
                />
                <InputField
                    label={organizationalFields[2].label}
                    name={organizationalFields[2].name}
                    value={organizationalFields[2].value}
                    placeholder={organizationalFields[2].placeholder}
                    type={organizationalFields[2].type}
                    required={organizationalFields[2].required}
                    onChange={e => handleOrgChange(2, e.target.value)}
                />
                <InputField
                    label={organizationalFields[3].label}
                    name={organizationalFields[3].name}
                    value={organizationalFields[3].value}
                    placeholder={organizationalFields[3].placeholder}
                    type={organizationalFields[3].type}
                    required={organizationalFields[3].required}
                    onChange={e => handleOrgChange(3, e.target.value)}
                />
                <InputField
                    label={organizationalFields[4].label}
                    name={organizationalFields[4].name}
                    value={organizationalFields[4].value}
                    placeholder={organizationalFields[4].placeholder}
                    type={organizationalFields[4].type}
                    required={organizationalFields[4].required}
                    onChange={e => handleOrgChange(4, e.target.value)}
                />
                <InputField
                    label={organizationalFields[5].label}
                    name={organizationalFields[5].name}
                    value={organizationalFields[5].value}
                    placeholder={organizationalFields[5].placeholder}
                    type={organizationalFields[5].type}
                    required={organizationalFields[5].required}
                    onChange={e => handleOrgChange(5, e.target.value)}
                />
                <InputField
                    label={organizationalFields[6].label}
                    name={organizationalFields[6].name}
                    value={organizationalFields[6].value}
                    placeholder={organizationalFields[6].placeholder}
                    type={organizationalFields[6].type}
                    required={organizationalFields[6].required}
                    onChange={e => handleOrgChange(6, e.target.value)}
                />
                <InputField
                    label={organizationalFields[7].label}
                    name={organizationalFields[7].name}
                    value={organizationalFields[7].value}
                    placeholder={organizationalFields[7].placeholder}
                    type={organizationalFields[7].type}
                    required={organizationalFields[7].required}
                    onChange={e => handleOrgChange(7, e.target.value)}
                />
            </FormSection>

            <FormSection title="Partnership Details">
                <InputField
                    label={partnershipFields[0].label}
                    name={partnershipFields[0].name}
                    value={partnershipFields[0].value}
                    placeholder={partnershipFields[0].placeholder}
                    type={partnershipFields[0].type}
                    required={partnershipFields[0].required}
                    onChange={e => handlePartnerChange(0, e.target.value)}
                />
                <TextArea
                    label={partnershipFields[1].label}
                    placeholder={partnershipFields[1].placeholder}
                    minHeight="180px"
                    name={partnershipFields[1].name}
                    type={partnershipFields[1].type}
                    value={partnershipFields[1].value}
                    onChange={e => handlePartnerChange(1, e.target.value)}
                />
                <div className="flex gap-3">
                    <InputField
                        label={partnershipFields[2].label}
                        name={partnershipFields[2].name}
                        value={partnershipFields[2].value}
                        placeholder={partnershipFields[2].placeholder}
                        type={partnershipFields[2].type}
                        required={partnershipFields[2].required}
                        onChange={e => handlePartnerChange(2, e.target.value)}
                    />
                    <InputField
                        label={partnershipFields[3].label}
                        name={partnershipFields[3].name}
                        value={partnershipFields[3].value}
                        placeholder={partnershipFields[3].placeholder}
                        type={partnershipFields[3].type}
                        required={partnershipFields[3].required}
                        onChange={e => handlePartnerChange(3, e.target.value)}
                    />
                </div>
                <div className="flex gap-3">
                    <InputField
                        label={partnershipFields[4].label}
                        name={partnershipFields[4].name}
                        value={partnershipFields[4].value}
                        placeholder={partnershipFields[4].placeholder}
                        type={partnershipFields[4].type}
                        required={partnershipFields[4].required}
                        onChange={e => handlePartnerChange(4, e.target.value)}
                    />
                    <InputField
                        label={partnershipFields[5].label}
                        name={partnershipFields[5].name}
                        value={partnershipFields[5].value}
                        placeholder={partnershipFields[5].placeholder}
                        type={partnershipFields[5].type}
                        required={partnershipFields[5].required}
                        onChange={e => handlePartnerChange(5, e.target.value)}
                    />
                </div>
                <TextArea
                    label={partnershipFields[6].label}
                    placeholder={partnershipFields[6].placeholder}
                    minHeight="180px"
                    name={partnershipFields[6].name}
                    type={partnershipFields[6].type}
                    value={partnershipFields[6].value}
                    onChange={e => handlePartnerChange(6, e.target.value)}
                />
                <InputField
                    label={partnershipFields[7].label}
                    name={partnershipFields[7].name}
                    value={partnershipFields[7].value}
                    placeholder={partnershipFields[7].placeholder}
                    type={partnershipFields[7].type}
                    required={partnershipFields[7].required}
                    onChange={e => handlePartnerChange(7, e.target.value)}
                />
                <div className="flex gap-3">
                    <InputField
                        label={partnershipFields[8].label}
                        name={partnershipFields[8].name}
                        value={partnershipFields[8].value}
                        placeholder={partnershipFields[8].placeholder}
                        type={partnershipFields[8].type}
                        required={partnershipFields[8].required}
                        onChange={e => handlePartnerChange(8, e.target.value)}
                    />
                    <InputField
                        label={partnershipFields[9].label}
                        name={partnershipFields[9].name}
                        value={partnershipFields[9].value}
                        placeholder={partnershipFields[9].placeholder}
                        type={partnershipFields[9].type}
                        required={partnershipFields[9].required}
                        onChange={e => handlePartnerChange(9, e.target.value)}
                    />
                </div>
            </FormSection>

            <FormSection title="Compliance & Agreements">
                <InputField
                    label={ComplianceFields[0].label}
                    name={ComplianceFields[0].name}
                    value={ComplianceFields[0].value}
                    placeholder={ComplianceFields[0].placeholder}
                    type={ComplianceFields[0].type}
                    required={ComplianceFields[0].required}
                    onChange={e => handleComplianceChange(0, e.target.value)}
                />
                <InputField
                    label={ComplianceFields[1].label}
                    name={ComplianceFields[1].name}
                    value={ComplianceFields[1].value}
                    placeholder={ComplianceFields[1].placeholder}
                    type={ComplianceFields[1].type}
                    required={ComplianceFields[1].required}
                    onChange={e => handleComplianceChange(1, e.target.value)}
                />
            </FormSection>

            <FormSection title="Impact & Reporting">
                <InputField
                    label={impactFields[0].label}
                    name={impactFields[0].name}
                    value={impactFields[0].value}
                    placeholder={impactFields[0].placeholder}
                    type={impactFields[0].type}
                    required={impactFields[0].required}
                    onChange={e => handleImpactChange(0, e.target.value)}
                />
                <InputField
                    label={impactFields[1].label}
                    name={impactFields[1].name}
                    value={impactFields[1].value}
                    placeholder={impactFields[1].placeholder}
                    type={impactFields[1].type}
                    required={impactFields[1].required}
                    onChange={e => handleImpactChange(1, e.target.value)}
                />
                <TextArea
                    label={impactFields[2].label}
                    placeholder={impactFields[2].placeholder}
                    minHeight="180px"
                    name={impactFields[2].name}
                    type={impactFields[2].type}
                    value={impactFields[2].value}
                    onChange={e => handleImpactChange(2, e.target.value)}
                />
            </FormSection>

            {/* <ImpactReportingForm handleSubmit={handleSubmit} /> */}

            <div className="flex mt-5 justify-between">
                <ActionButton
                    variant={'reset'}
                    text={'Reset Form'}
                />
                <div className="flex gap-5">
                    <ActionButton
                        variant={'cancel'}
                        text={'Cancel'}
                    />
                    <ActionButton
                        variant={'submit'}
                        text={'Submit'}
                        handleSubmit={handleSubmit}
                    />
                </div>
            </div>
            <ToastContainer
                position = "top-right"
                autoClose={1000}
            />
        </form>
    );
}

export default NgoEdit;